import type { FunctionComponent, MouseEventHandler } from 'react';

import { forTemplate } from '@trello/legacy-i18n';
import { Button } from '@trello/nachos/button';

import styles from './GenerateApiKeyModal.less';

const format = forTemplate('app_management');

export const GenerateApiKeyModal: FunctionComponent<{
  generateApiKey: (
    key: string | null,
  ) => MouseEventHandler<HTMLButtonElement> | undefined;
  hide: () => void;
}> = ({ generateApiKey, hide }) => {
  return (
    <div className={styles.modal}>
      <div className={styles.modalHeader}>
        <h1>{format('generate-api-key')}</h1>
      </div>
      <div className={styles.modalBody}>
        <p
          // eslint-disable-next-line @eslint-react/dom/no-dangerously-set-innerhtml -- FIXME
          dangerouslySetInnerHTML={{
            __html: format('generating-a-unique-api-key'),
          }}
        />
        <p>{format('fourteen-to-update-api-key')}</p>
      </div>
      <div className={styles.modalFooter}>
        <Button onClick={hide}>{format('cancel')}</Button>
        <Button
          className={styles.generateBtn}
          children={format('generate-api-key')}
          appearance="primary"
          onClick={generateApiKey(null)}
        />
      </div>
    </div>
  );
};
